import LogoVipDe from '../../src/legacy/LogoVipDe';
export default LogoVipDe;
